export type ServiceFeeTerms = {
    visible: boolean;
    startsOn: string;
    thresholdCents: number;
    percentage: number;
    maxCents: number;
};

export type ServiceFeeBalanceStatus = {
    pendingServiceFeesCents: number;
    gracePeriodStartedAt: string | null;
    gracePeriodEndsAt: string | null;
    gracePeriodDaysRemaining: number | null;
    gracePeriodActive: boolean;
    confirmationBlocked: boolean;
    lowBalance: boolean;
    lowBalanceThresholdCents: number;
};

export type ServiceFeePageProps = {
    serviceFeeAnnouncement?: ServiceFeeTerms;
    serviceFeeBalanceStatus?: ServiceFeeBalanceStatus;
};

export const formatServiceFeeMoney = (amountCents: number) =>
    new Intl.NumberFormat('uk-UA', {
        style: 'currency',
        currency: 'UAH',
        maximumFractionDigits: 2,
    }).format(amountCents / 100);

export const calculateServiceFeeCents = (
    orderTotal: number,
    terms: ServiceFeeTerms,
) => {
    const orderTotalCents = Math.round(orderTotal * 100);
    if (orderTotalCents <= terms.thresholdCents) return 0;

    return Math.min(
        Math.round((orderTotalCents * terms.percentage) / 100),
        terms.maxCents,
    );
};

export const formatServiceFeeDate = (date: string) =>
    new Intl.DateTimeFormat('uk-UA', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone: 'UTC',
    }).format(new Date(`${date}T00:00:00Z`));

export const formatServiceFeeShortDate = (date: string) =>
    new Intl.DateTimeFormat('uk-UA', {
        day: 'numeric',
        month: 'long',
        timeZone: 'UTC',
    }).format(new Date(`${date}T00:00:00Z`));
